var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.qualityNotifications),function(qualityNotification){return _c('quality-notification-component',{key:qualityNotification.Id,attrs:{"qualityNotification":qualityNotification}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }